import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppValidators } from 'src/app/app.validator';
import { VerifyModel } from 'src/app/models/me.model';
import { MeService } from 'src/app/services/me.service';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { AppInsightsService } from 'src/app/services/appinsights.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    host: { 'style': 'width: 100%', 'display': 'block' }
})
export class ResetPasswordComponent implements OnInit {

    form: UntypedFormGroup;
    submitted: boolean = false;
    submitting: boolean = false;
    errors: string[] = [];
    completed: boolean = false;
    attempts: number = 3;
    guid: string = '';
    username: string;
    pinSentDialogShown = false;
    _resendSecurityTokenDisabled: boolean = true;
    pinCodeRequested: boolean = false; 

    accesscodeTextMask = createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        integerLimit: 4,
        allowLeadingZeroes: true
    });

    constructor(
        private route: ActivatedRoute,
        fb: UntypedFormBuilder,
        private meService: MeService,
        private appInsightsService: AppInsightsService
    ) {
        this.form = fb.group({
            'accesscode': [null, Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(4)])],
            'password': [null, Validators.compose([Validators.required, AppValidators.password])],
            'passwordagain': [null, null]
        }, { validator: AppValidators.passwordmatch });
    }

    ngOnInit() {
        this.guid = this.route.snapshot.params.guid;
        this.pinSentDialogShown = true;
    }

    closePinDialog() {
        this._resendSecurityTokenDisabled = true;
        this.pinSentDialogShown = false;

        setTimeout(() => {
            this._resendSecurityTokenDisabled = false;
        }, 30 * 1000);
    }

    requestAccessCode() {
        this._resendSecurityTokenDisabled = true;
        this.pinSentDialogShown = true;
        this.pinCodeRequested = true;

        this.meService.forgottenPassword(this.guid).subscribe({
            next: (result) => {
                this.appInsightsService.logCustomEvent(`RequestAccessCodePassword ${this.guid}`, 'Succeeded', result.username);
                this.username = result.username;
            },
            error: () => {
                this.appInsightsService.logCustomEvent(`RequestAccessCodePassword ${this.guid}`, 'Failed', '');
            }
        });
    }

    onRequestAccessCode() {
        this.pinCodeRequested = true;
        this.pinSentDialogShown = false;

        this.requestAccessCode();

        setTimeout(() => {
            this._resendSecurityTokenDisabled = false;
        }, 30 * 1000);
    }

    clear() {
        this.errors = [];
    }

    submit(form: UntypedFormGroup) {
        this.submitted = true;
        if (form.invalid) { return; }
        form.disable();
        this.submitting = true;

        const model: VerifyModel = {
            code: form.value.accesscode,
            password: form.value.password,
            confirmPassword: form.value.passwordagain,
            registrationCode: this.guid,
            transactionId: ''
        };

        this.meService.forgottenPasswordVerify(model).subscribe(
            result => {
                this.submitting = false;
                this.completed = true;
                this.appInsightsService.logCustomEvent('Use access code ', 'Succeeded', this.username);
            },
            error => {
                form.enable();
                this.submitting = false;
                this.attempts -= 1;
                const response = error ? error.error : undefined;
                if (response && response.Expired) { this.attempts = 0; }
                this.errors = ['Please enter a valid access code'];
                this.appInsightsService.logCustomEvent('Use access code ', 'Failed', this.username);
            }
        );
    }
}
